// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_exceptions from "../../../node_modules/rescript/lib/es6/caml_exceptions.js";
import * as ErrorUtils$Catalyst from "../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

var UnsupportedGeoregion_fromString_Not_found = /* @__PURE__ */Caml_exceptions.create("GeoRegion.UnsupportedGeoregion_fromString_Not_found");

function fromString(geo_region) {
  switch (geo_region) {
    case "Ahmedabad" :
        return /* Ahmedabad */5;
    case "Bangalore" :
        return /* Bangalore */2;
    case "Chennai" :
        return /* Chennai */4;
    case "Delhi NCR" :
        return /* Delhi */1;
    case "Hyderabad" :
        return /* Hyderabad */3;
    case "Kolkata" :
        return /* Kolkata */8;
    case "Mumbai" :
        return /* Mumbai */0;
    case "Pune" :
        return /* Pune */7;
    default:
      return ErrorUtils$Catalyst.raiseError("GeoRegion.res", "Invalid Geo Region", geo_region);
  }
}

function toString(geo_region) {
  switch (geo_region) {
    case /* Mumbai */0 :
        return "Mumbai";
    case /* Delhi */1 :
        return "Delhi NCR";
    case /* Bangalore */2 :
        return "Bangalore";
    case /* Hyderabad */3 :
        return "Hyderabad";
    case /* Chennai */4 :
        return "Chennai";
    case /* Ahmedabad */5 :
        return "Ahmedabad";
    case /* Pune */7 :
        return "Pune";
    case /* Kolkata */8 :
        return "Kolkata";
    case /* Jaipur */6 :
    case /* Surat */9 :
    case /* Lucknow */10 :
    case /* Coimbatore */11 :
    case /* Indore */12 :
    case /* Nagpur */13 :
    case /* Chandigarh */14 :
    case /* Vadodara */15 :
    case /* Ludhiana */16 :
    case /* Kochi */17 :
    case /* Nashik */18 :
    case /* Kanpur */19 :
        break;
    case /* Other */20 :
        return "Other";
    
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "GeoRegion.res",
          45,
          2
        ],
        Error: new Error()
      };
}

function fromId(gId) {
  if (gId > 20 || gId < 1) {
    return /* Other */20;
  } else {
    return gId - 1 | 0;
  }
}

export {
  UnsupportedGeoregion_fromString_Not_found ,
  fromString ,
  toString ,
  fromId ,
  
}
/* No side effect */
